import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FlipBonus extends Bloc {

	constructor (src, ctx, target) {

		super("flipbonus", src, ctx);
		this.f = (src, ins) => [src.master.player.hasStatus("facing-back") ? src.master.player.getStatusValue("energetic") * (src.model && src.model.scaling || 1) : 0];
		this.types = [];
	}
}